<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="vendas.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="vendas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma venda encontrada"
      loading-text="Carregando vendas..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        {{ id(item) }}
      </template>
      <template v-slot:item.nome="{ item }">
        <px-situacao-compra-icon :situacao="item.situacao"/>
        {{ item.nome }}
      </template>
      <template v-slot:item.dataCompra="{ item }">
        {{ item.dataCompra | date }}
      </template>
      <template v-slot:item.quantidadeProdutos="{ item }">
        {{ item.quantidadeProdutos }} produto(s)
      </template>
      <template v-slot:item.total="{ item }">
        {{ item.total | currency }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="link(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    vendas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Cliente',
          value: 'nome',
        },
        {
          text: 'Data da compra',
          value: 'dataCompra',
        },
        {
          text: 'Quantidade de itens',
          value: 'quantidadeProdutos',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    link() {
      return (item) => `venda/${item.compraId}`;
    },
    id() {
      return (item) => item.compraId;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
